module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10253.eb3ed1b3.jpg";